import React, { useState, useEffect } from "react";
import { addAdminUser } from "../../../Services/postServices";
import { getZoneList } from "../../../Services/getServices";
import { ssoRoleBydomain } from "../../../Services/getServices";
import { loader } from "../../../redux/type";
import { useDispatch } from "react-redux";
// import AddAdmin from "../AddAdmin";
import { toast } from "react-toastify";
import Select from "react-select";

const AdminAawaas = (props) => {
  const mobNum = localStorage.getItem("moblie");
  const dispatch = useDispatch();
  console.log("DOMAINCIODE=", props?.data?.domainCode);
  // const roles=props?.data?.rolesList;
  const domainC = props?.data?.domainCode;
  const userData = JSON.parse(localStorage.getItem("user"));
  //   console.log("DATATATA=", userData?.user?.id);
  // const id=userData?.user?.id

  const id = userData?.domainCodesByUserId[0]?.userId;

  var [name, setName] = useState("");

  var [mobileNo, setMobileNo] = useState("");

  var [email, setEmail] = useState("");
  var [dept, setDept] = useState("");
  var [desig, setDesig] = useState("");
  var [zone, setZone] = useState("");
  var [cat, setCat] = useState("");
  var [userId, setUserId] = useState("");
  var [pass, setPass] = useState("");
  var [zoneArr, setZoneArr] = useState([]);
  var [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    zoneList();
    // deptByDomainName();
    ssoRoleByDomainName(domainC);
    // ssoRoleBydeptId();
    // desigByDomainName();
    // desigByDeptId();
  }, []);

  


 
var[optRoles,setOptRoles]=useState([]);
  function ssoRoleByDomainName(domainCo) {
    ssoRoleBydomain(domainCo, (res) => {
      if (res?.data?.status) {
        setRolesList(res?.data?.result);
        console.log("roless", res?.data?.result);

        let arr5=res?.data?.result;
       const arr6= arr5.map((i)=>({
          value: i.id,
          label:i.roleName,

        }))
        setOptRoles(arr6);


      } else {
      }
    });
  }
  console.log("dekhooo=",optRoles)

  function zoneList() {
    dispatch({ type: loader.startLoader });

    getZoneList((res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setZoneArr(res?.data?.result);
        console.log("ZONE=",res?.data?.result)
      } else {
      }
    });
  }

  function addUser() {
    let req = {
      userName: userId,
      createdBy: id.toString(),

      emailId: email,

      mobileNumber: mobileNo,

      firstName: name,

      zone: zone,
      domainCode: domainC,

      designation: desig,
      isAdmin: "Y",
      roles: [4],
      userType: "1",

      password: pass,
      retypePassword: pass,

      departmentName: domainC,

      isAdmin: "Y",
      // "roles":[1,2,3,4],
      dob: "2005-02-02",
    };
    dispatch({ type: loader.startLoader });
    addAdminUser(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        window.location.reload();
      } else {
        toast.error(res?.data?.message);
      }
    });
  }

  const options = [
    { value: 1, label: "Apple" , zoneName:"A"},
    { value: 2, label: "Banana",zoneName:"AB" },
    { value: 3, label: "Cherry",zoneName:"ABC" },

  //   {
  //     "id": 1,
  //     "zoneCode": "G",
  //     "zoneName": "Not Given",
  //     "refStatusId": 1,
  //     "createdBy": 1,
  //     "createdAt": "2020-03-12T01:03:15.000+00:00",
  //     "updatedBy": 1,
  //     "updatedAt": "2020-03-12T01:03:15.000+00:00",
  //     "isDeleted": 0
  // },
  // {
  //     "id": 2,
  //     "zoneCode": "W",
  //     "zoneName": "WEST",
  //     "refStatusId": 1,
  //     "createdBy": 1,
  //     "createdAt": "2020-03-12T01:03:15.000+00:00",
  //     "updatedBy": 1,
  //     "updatedAt": "2020-03-12T01:03:15.000+00:00",
  //     "isDeleted": 0
  // },
  // {
  //     "id": 3,
  //     "zoneCode": "N",
  //     "zoneName": "NORTH",
  //     "refStatusId": 1,
  //     "createdBy": 1,
  //     "createdAt": "2020-03-12T01:03:15.000+00:00",
  //     "updatedBy": 1,
  //     "updatedAt": "2020-03-12T01:03:15.000+00:00",
  //     "isDeleted": 0
  // },
  ];


  const zoneee= [
    {
        "id": 1,
        "zoneCode": "G",
        "zoneName": "Not Given",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 2,
        "zoneCode": "W",
        "zoneName": "WEST",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    },
    {
        "id": 3,
        "zoneCode": "N",
        "zoneName": "NORTH",
        "refStatusId": 1,
        "createdBy": 1,
        "createdAt": "2020-03-12T01:03:15.000+00:00",
        "updatedBy": 1,
        "updatedAt": "2020-03-12T01:03:15.000+00:00",
        "isDeleted": 0
    }
]


  const [selectedValues, setSelectedValues] = useState([]);
  const handleChange = (selected) => {
    const valuesOnly = selected ? selected.map((opt) => opt.value) : [];
    setSelectedValues(valuesOnly);
  };
  const selectedOptionObjects = options.filter((opt) =>
    selectedValues.includes(opt.value)
  );


  const [selectedDis, setSelectedDis] = useState([]);
  const handleZone = (selected1) => {
    const valuesOnly1 = selected1 ? selected1.map((opt1) => opt1.value) : [];
    setSelectedDis(valuesOnly1);
  };
  const selectedZoneObjects = optRoles.filter((opt1) =>
    selectedDis.includes(opt1.value)
  );

  console.log("ZONES=",selectedDis);
  console.log("ZONES=",selectedValues)
    

  return (
    <>
      <div className="row ">

          {/* <Select
              isMulti
            
              options={options}
              value={selectedOptionObjects}
              getOptionLabel={(e)=>e.zoneName}
              onChange={handleChange}
              placeholder="Select Zone"
            />

            <Select
              isMulti
            
              options={optRoles }
              
              value={selectedZoneObjects}
              getOptionLabel={(e)=>e.label}
              onChange={handleZone}
              placeholder="Select Designation"
            /> */}


        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Name:
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Mobile Number:
            </label>
            <input
              type="mobile"
              onChange={(e) => setMobileNo(e.target.value)}
              // value={mobNum}
              //   disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Email:
            </label>
            <input
              type="mobile"
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        {/* <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Department Name:
            </label>
            <input
              type="mobile"
              onChange={(e) => setDept(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div> */}
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Designation :
            </label>

            <Select
              isMulti
            
              options={optRoles }
              
              value={selectedZoneObjects}
              getOptionLabel={(e)=>e.label}
              onChange={handleZone}
              placeholder="Select Designation"
            />

            {/* <select
              class="form-control form-select"
              onChange={(e) => {
                setDesig(e.target.value);
              }}
            >
              <option value="0">Select Designation </option>

              {rolesList.map((val) => {
                return (
                  <option key={val} value={val.roleId}>
                    {val.roleName}
                  </option>
                );
              })}
            </select> */}
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Zone:
            </label>
            <select
              class="form-control form-select"
              onChange={(e) => {
                setZone(e.target.value);
              }}
            >
              <option value="0">Select Domain </option>

              {zoneArr.map((val) => {
                return (
                  <option key={val} value={val.id}>
                    {val.zoneName}
                  </option>
                );
              })}
            </select>


          </div>
        </div>

        {/* <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Category:
            </label>
            <input
              type="mobile"
              onChange={(e) => setCat(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div> */}
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              User Id:
            </label>
            <input
              type="mobile"
              onChange={(e) => setUserId(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Password:
            </label>
            <input
              type="mobile"
              onChange={(e) => setPass(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4 " >
          <div className="form-outline" style={{marginTop:"2rem"}}>
            <button className="btn btn-primary" onClick={addUser}>
              Create Admin
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminAawaas;
